var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticStyle: {
            position: "absolute",
            top: "0",
            right: "0",
            left: "0",
            bottom: "0",
            "background-color": "rgba(0, 0, 0, 0.2)",
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              if ($event.target !== $event.currentTarget) return null
            },
          },
        },
        [
          _vm.visible
            ? _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    margin: "auto",
                    top: "0",
                    right: "0",
                    bottom: "0",
                    left: "0",
                    width: "400px",
                    "border-radius": "2px",
                    "background-color": "#ededed",
                    "box-shadow": "0 0 5px rgba(0, 0, 0, 0.2)",
                  },
                  style: { height: _vm.CurrentHeight },
                },
                [
                  _c("div", { staticStyle: { height: "100%" } }, [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "border-bottom": "1px solid #bbb",
                          "text-align": "center",
                          height: "45px",
                          "line-height": "45px",
                        },
                      },
                      [_vm._v("提示")]
                    ),
                    _c("div", [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            height: "25px",
                            "line-height": "25px",
                            "padding-left": "50px",
                            "font-size": "13px",
                            "font-weight": "600",
                            "margin-top": "10px",
                          },
                        },
                        [_vm._v("您还未设置昵称，请设置昵称方便与网点沟通问题")]
                      ),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            height: "25px",
                            "line-height": "25px",
                            "padding-left": "50px",
                            "font-size": "12px",
                            color: "#999",
                          },
                        },
                        [
                          _vm._v(
                            "昵称实例：真实姓名、xx店铺客服、xx商家仓储管理员"
                          ),
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            height: "40px",
                            "line-height": "40px",
                            "padding-left": "50px",
                          },
                        },
                        [
                          _c("span", [_vm._v("昵称")]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.nick,
                                expression: "nick",
                              },
                            ],
                            staticStyle: {
                              height: "30px",
                              "line-height": "30px",
                              "margin-left": "15px",
                              width: "245px",
                              "border-radius": "3px",
                              border: "none",
                            },
                            attrs: {
                              maxlength: "16",
                              type: "text",
                              name: "fname",
                            },
                            domProps: { value: _vm.nick },
                            on: {
                              keyup: _vm.forbidSpace,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.nick = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                      _vm.nickFlag
                        ? _c(
                            "p",
                            {
                              staticStyle: {
                                height: "20px",
                                "line-height": "20px",
                                "padding-left": "50px",
                                "font-size": "12px",
                                color: "#red",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "18px",
                                    height: "18px",
                                    "border-radius": "50%",
                                    background: "red",
                                    "vertical-align": "middle",
                                    "text-align": "center",
                                    "font-size": "12px",
                                    color: "#fff",
                                    transform: "scale(0.8)",
                                  },
                                },
                                [_vm._v("!")]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    display: "inline-block",
                                    "vertical-align": "middle",
                                    color: "red",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.tipNameMsg))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.errorMsg
                        ? _c(
                            "p",
                            {
                              staticStyle: {
                                height: "20px",
                                "line-height": "20px",
                                "padding-left": "50px",
                                "font-size": "12px",
                                color: "#red",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "18px",
                                    height: "18px",
                                    "border-radius": "50%",
                                    background: "red",
                                    "vertical-align": "middle",
                                    "text-align": "center",
                                    "font-size": "12px",
                                    color: "#fff",
                                    transform: "scale(0.8)",
                                  },
                                },
                                [_vm._v("!")]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    display: "inline-block",
                                    "vertical-align": "middle",
                                    color: "red",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.errorMsg))]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "margin-top": "10px",
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            staticStyle: {
                              width: "74px",
                              height: "36px",
                              "border-radius": "4px",
                              background: "#fff",
                              color: "#494C4F",
                              border: "1px solid #bbb",
                              "margin-right": "26px",
                            },
                            attrs: { type: "button" },
                            on: { click: _vm.closeAll },
                          },
                          [_vm._v("取消")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            staticStyle: {
                              width: "74px",
                              height: "36px",
                              "border-radius": "4px",
                              background: "#653EB3",
                              color: "#fff",
                              border: "1px solid #653EB3",
                            },
                            attrs: { type: "button" },
                            on: { click: _vm.upDataMyInfo },
                          },
                          [_vm._v("确定")]
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }